export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const LANDING = "/";
export const HOME = "/Home";
export const ACCOUNT = "/account";
export const PASSWORD_FORGET = "/pw-forget";
export const PASSWORD_CHANGE = "/pw-change";
export const STUDENT_PAGE = "/spage";
export const ABOUTME ="/AboutMe"
export const QUEUE ="/q"
export const QUEUE_LIST ="/qlist"
export const A_REGISTER ="/advisor-register"
export const A_LOGIN ="/advisor-login"
export const A_HOME ="/advisor-home"
export const A_ABOUT ="/advisor-about"
export const A_INFO ="/appinfo"
export const A_CLASS ="/advisor-class"

